import { Component, OnInit, Input, ViewChild, ViewContainerRef, ComponentRef, ComponentFactoryResolver, Output, EventEmitter } from '@angular/core';
// import { CourseService } from 'src/app/services/course.service';
import { ExerciseResultComponent } from '../exercise-result/exercise-result.component';
// import { UtilityService } from 'src/app/services/utility.service';
import { timeInterval } from 'rxjs/operators';
import { UtilityService } from 'src/app/shared/utils/utility.service';
import { CourseService } from 'src/app/shared/services/course.service';

@Component({
  selector: 'app-await-response',
  templateUrl: './await-response.component.html',
  styleUrls: ['./await-response.component.css']
})
export class AwaitResponseComponent implements OnInit {


  @Output() endScreeen: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  @Input() nextItemId;
  @Input() courseId: any;
  @Input() exerciseId: any;
  @Input() set attemptedExercise(attemptedExercise) {

    if (attemptedExercise) {
      this._attemptedExercise = attemptedExercise;
      console.log(this._attemptedExercise);

      this.destroyComponent();
    }
  }
  @Output()
  seeResponse: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  @Input() exerciseData: any = null;
  @Input()
  exerciseDetails: {
    moduleName: string,
    title: string,
    duration: number,
    numberOfQuestions: number,
    courseTitle: string,
    type: string
  };
  @Input() isMuteScores:boolean;
  _attemptedExercise: any
  private resultFactory: any;
  @ViewChild('result', { read: ViewContainerRef }) result: ViewContainerRef;
  componentRef: ComponentRef<any>;
  constructor(private resolver: ComponentFactoryResolver, private utilityService: UtilityService, private courseService: CourseService) { }

  ngOnInit() {
  }
  ngAfterContentInit() {
    this.resultFactory = this.resolver.resolveComponentFactory(ExerciseResultComponent);
  }

  ngAfterViewInit() {
    this.utilityService.destroyComponent$.subscribe(res => res && this.destroyComponent());
  }

  next() {
    if (this.nextItemId)
      this.courseService.setcurrentPlayedItem(this.nextItemId);
    else this.endScreeen.emit(true);
  }

  seeExerciseResult() {
    this.componentRef = this.result.createComponent(this.resultFactory);
    this.componentRef.instance.courseId = this.courseId;
    this.componentRef.instance.exerciseId = this.exerciseId;
    this.exerciseData && (this.componentRef.instance.exerciseData = this.exerciseData);
    this.utilityService.isBackRequired = true;
    this.seeResponse.emit(true);
  }

  destroyComponent() {
    this.utilityService.isBackRequired = false;
    this.componentRef && this.componentRef.destroy();
    this.componentRef = null;
  }

  get timeLeft() {
    let resultDate = new Date(Date.parse(this._attemptedExercise.dateOfSubmission));
    resultDate.setHours(resultDate.getHours() + 48);
    let currentDate = new Date();
    const diffTime = resultDate.getTime() - currentDate.getTime();
    if (diffTime > 0) {
      const diffHours = Math.ceil(diffTime / (1000 * 60 * 60));
      return diffHours;
    }
    else {
      return 0;
    }
  }
}
